import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { SelectCheckAllComponent } from './select-check-all.component';

@NgModule({
    imports: [CommonModule, MatSelectModule, MatCheckboxModule],
    declarations: [SelectCheckAllComponent],
    exports: [MatSelectModule, MatCheckboxModule, SelectCheckAllComponent]
})
export class SelectCheckAllModule { }


